export default __webpack_public_path__ + "static/media/red-warning.f1910372.svg";